<!-- HR -->
<div *ngIf="field.type === 'hr'" class="col-12">
  <hr />
</div>

<!-- AutoComplete -->
<div *ngIf="field.type === 'auto-complete'" >
  <app-auto-complete
    [checkValidation]="field.checkValidation"
    [idSelect]="field.idSelect"
    [keyRequired]="field.keyRequired"
    [options]="field.options"
    [header]="field.header"
    [placeholder]="field.placeholder"
    [existingValue]="field.existingValue"
    [id]="field.id"
    [icon]="field.icon ?? false"
    [iconName]="field.iconName ?? ''"
    (requiredKey)="requiredKey.emit($event)"
    (selecteditem)="selecteditem.emit($event)">
  </app-auto-complete>
</div>

<!-- Select Dropdown -->
<div *ngIf="field.type === 'select-dropdown'" >
  <app-select-dropdown
    [ShowEdit]="field.showEdit ?? false"
    [checkValidation]="field.checkValidation"
    [keyRequired]="field.keyRequired"
    [options]="field.options"
    [header]="field.header"
    [placeholder]="field.placeholder"
    [existingValue]="field.existingValue"
    [id]="field.id"
    [ShowAdd]="field.ShowAdd ?? false"
    [APIUrl]="field.api?.url ?? ''"
    [icon]="field.icon ?? false"
    [iconName]="field.iconName ?? ''"
    (requiredKey)="requiredKey.emit($event)"
    (selecteditem)="selecteditem.emit($event)"
    (reloadOptions)="reloadOptions.emit($event)">
  </app-select-dropdown>
</div>

<!-- Input -->
<div *ngIf="field.type === 'input'" >
  <app-input
    [checkValidation]="field.checkValidation"
    [keyRequired]="field.keyRequired"
    [placeholder]="field.placeholder"
    [header]="field.header"
    [pattern]="field.pattern"
    [patternMessage]="field.patternMessage || field.regexMessage"
    [disabled]="field.disabled"
    [readonly]="field.readonly"
    [existingValue]="field.existingValue"
    [id]="field.id"
    [icon]="field.icon ?? false"
    [iconName]="field.iconName ?? ''"
    [helpText]="field.helpText ?? ''"
    (requiredKey)="requiredKey.emit($event)"
    [type]="field.typeText"
    (selecteditem)="selecteditem.emit($event)">
  </app-input>
</div>

<!-- Textarea -->
<div *ngIf="field.type === 'textarea'" >
  <app-textarea
    [checkValidation]="field.checkValidation"
    [keyRequired]="field.keyRequired"
    [placeholder]="field.placeholder"
    [disabled]="field.disabled"
    [header]="field.header"  
    [pattern]="field.pattern"
    [existingValue]="field.existingValue"
    [id]="field.id"
    (requiredKey)="requiredKey.emit($event)"
    (selecteditem)="selecteditem.emit($event)">
  </app-textarea>
</div>

<!-- Radio -->
<div *ngIf="field.type === 'radio'" >
  <app-radio-group
    [checkValidation]="field.checkValidation"
    [keyRequired]="field.keyRequired"
    [names]="field.options"
    [existingValue]="field.existingValue"
    [id]="field.id"
    (requiredKey)="requiredKey.emit($event)"
    (selecteditem)="selecteditem.emit($event)">
  </app-radio-group>
</div>

<!-- Checkbox -->
<div *ngIf="field.type === 'checkbox'" >
  <app-checkbox
    [checkValidation]="field.checkValidation"
    [keyRequired]="field.keyRequired"
    [names]="field.options"
    [existingValue]="field.existingValue"
    [id]="field.id"
    (requiredKey)="requiredKey.emit($event)"
    (selectedItems)="selectedItems.emit($event)">
  </app-checkbox>
</div>

<!-- Date -->
<div *ngIf="field.type === 'date'" >
  <app-date
    [checkValidation]="field.checkValidation"
    [keyRequired]="field.keyRequired"
    [header]="field.header"
    [existingValue]="field.existingValue"
    [id]="field.id"
    [icon]="field.icon ?? false"
    [iconName]="field.iconName ?? ''"
    (requiredKey)="requiredKey.emit($event)"
    (selecteditem)="selecteditem.emit($event)">
  </app-date>
</div>

<!-- Group -->
<div *ngIf="field.type === 'group'" >
  <div class="card p-10">
    <span class="fw-bold w-100 mb-2">{{ field.header }}</span>
    <div class="row">
      <ng-container *ngFor="let child of field.children">
        <app-dynamic-field
          [field]="child"
          class="{{child.class}}"
          (requiredKey)="requiredKey.emit($event)"
          (selecteditem)="selecteditem.emit($event)"
          (selectedItems)="selectedItems.emit($event)"
          (reloadOptions)="reloadOptions.emit($event)">
        </app-dynamic-field>
      </ng-container>
    </div>
  </div>
</div>
<!-- Tabs -->
<div *ngIf="field.type === 'tabs'">
  <ul class="nav nav-pills nav-primary" ngbNav #tabNav="ngbNav"
      [(activeId)]="field.active" [destroyOnHide]="false">
    <li class="nav-item" *ngFor="let tab of field.tabs" [ngbNavItem]="tab.id">
      <a class="nav-link1 nav-dark" ngbNavLink>
        {{ tab.title }}
        <span *ngIf="isTabEdited(tab.id)">
          <img src="assets/DashboardIcon/editbutton.png" alt="Edited" style="height: 16px; width: 16px;">
        </span>
      </a>

      <ng-template ngbNavContent>
        <div class="row">
          <ng-container *ngFor="let child of tab.children">
            <app-dynamic-field
              class="{{child.class}}"
              [field]="child"
              (requiredKey)="markTabAsEdited(tab.id, $event, 'requiredKey'); requiredKey.emit($event)"
              (selecteditem)="markTabAsEdited(tab.id, $event, 'selecteditem'); selecteditem.emit($event)"
              (selectedItems)="markTabAsEdited(tab.id, $event, 'selectedItems'); selectedItems.emit($event)"
              (reloadOptions)="markTabAsEdited(tab.id, $event, 'reloadOptions'); reloadOptions.emit($event)">
            </app-dynamic-field>
          </ng-container>
        </div>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="tabNav" class="mt-3"></div>
</div>
